export const generateTimeRange = (interval: number) => {
  const x = interval;
  const times = []; // time array
  let tt = 7 * 60; // start time
  const ap = ['AM', 'PM']; // AM-PM

  for (let i = 0; tt < 24 * 60; i++) {
    const hh = Math.floor(tt / 60);
    const mm = (tt % 60);
    // times[i] = ('0' + (hh % 12)).slice(-2) + ':' + ('0' + mm).slice(-2) + ap[Math.floor(hh / 12)]; // pushing data in array in [00:00 - 12:00 AM/PM format]
    times[i] = {time: (('0' + hh).slice(-2) + ':' + ('0' + mm).slice(-2)), value: `${mm} ${hh}`}; // pushing data in array in [00:00 - 12:00 AM/PM format]
    tt = tt + x;
  }
  return times;
};
